import React from "react";
import { t } from "i18next";
import C from "Constants";
import { useSelector } from "react-redux";
import { FormatPreOrderingTime } from "utils/OrderUtils";
import { SVGICONS } from "config";
import { PreOrderingDisplayTimingWidget } from "components/Pre-ordering";
import moment from "moment";
import { TranslationText } from "components/TextTranslationContainer";
import { CustomButton } from "components/Button";

const DeliveryTime = ({ setPreOrderingSlotWidget }) => {
  const { orderTiming } = useSelector((state) => state?.orderTimingReducer);
  const { orderType } = useSelector((state) => state?.AppReducer);

  return (
    <>
      <TranslationText
        text={
          orderType?.serviceType === C.SERVICE_TYPE.DELIVERY
            ? "Delivery Time"
            : orderType?.serviceType === C.SERVICE_TYPE.PICKUP
            ? "Pickup Time"
            : null
        }
        className="text-16x font-medium text-shadow-forge-900"
        as="h3"
      />

      <div
        className="flex items-start gap-3 justify-between rounded-16x px-4 py-3 text-shadow-forge-800"
        style={{ border: "1.5px solid #E5E7EB" }}
      >
        <SVGICONS.TimeIcon
          className="flex-shrink-0"
          width={20}
          height={20}
        />

        <span className="break-all text-14x w-full break-words block flex-1 ">
          {orderTiming?.TimingType === C.ORDER_TIMING_TYPE.PREORDER ? (
            orderTiming?.isPreOrderAvailable &&
            orderTiming?.preOrderSlot && (
              <>
                {orderTiming?.preOrderSlot?.day === C.TODAY
                  ? t(orderTiming?.preOrderSlot?.day)
                  : moment(orderTiming?.preOrderSlot?.day).format(
                      "dddd, DD MMM YYYY"
                    )}
                {", "}
                {FormatPreOrderingTime(orderTiming?.preOrderSlot?.time)}
              </>
            )
          ) : (
            <> {t("ASAP")}</>
          )}
        </span>
        <CustomButton
          id="delivery-address-change"
          onClick={() => setPreOrderingSlotWidget(true)}
          className="w-fit"
          outline
          style={{
            padding: "0px 5px",
            borderRadius: "8px",
          }}
        >
          <TranslationText text="Change" />
        </CustomButton>
      </div>
     {orderTiming?.TimingType === C.ORDER_TIMING_TYPE.PREORDER
        ? orderTiming?.isPreOrderAvailable &&
          orderTiming?.preOrderSlot && (
            <div className="mb-2">
              <PreOrderingDisplayTimingWidget route="checkout" />
            </div>
          )
        : null}
    </>
  );
};

export default DeliveryTime;
